/**
 * Особисті налаштування на сервері (prefs/sync.ts) і вхід у «Мій профіль» з оболонки (меню
 * користувача, палітра). Не входить у зведений `uk.ts`: документ входу цих текстів не потребує.
 * Імпортувати напряму; перетин ключів перевіряє `uk.test.ts`.
 */
export const prefsText = {
  prefsSaved: 'Збережено',
  prefsSaveFailed: 'Не вдалося зберегти налаштування. Повернуто попереднє значення',
  profileLink: 'Мій профіль',
  startFallback: 'Стартова сторінка з профілю вам зараз недоступна. Відкрито типову',
  profileWords: ['профіль', 'налаштування', 'ім’я', 'email', 'пошта', 'стартова сторінка'],
} as const;
